<template>
  <div style="height: 35px; background-color: #DFDFDF">
    <v-layout row fill-height align-center class="progress-container">
      <div class="progress-bar" :style="{width: progressWidth}"></div>
      <v-flex
        v-for="(step, stepIndex) in steps"
        :key="'step' + stepIndex"
        class="text-xs-center"
        :class="{'active':stepActive(step)}"
      >{{ step.charAt(0).toUpperCase() + step.substring(1) }}</v-flex>
    </v-layout>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  computed: {
    step: function() {
      return this.$store.getters.wizardNavigator.progressStep;
    },
    steps: function() {
      let steps = ['trip'];
      
      if(this.showSizeAndStyle) {
        if(this.styleFirst) {
          steps.unshift('size');
          steps.unshift('style');
        } else {
          steps.push('style');
          steps.push('size');
        }
      }
      steps.push('lookbook');
      steps.push('checkout');

      return steps;
    },
    progressWidth: function() {
      if(!this.showSizeAndStyle) {
        if(this.step == 'trip') return '33%';
        if(this.step == 'lookbook') return '66%';
        if(this.step == 'checkout') return '100%';
      }

      if(this.styleFirst) {
        if(this.step == 'style') return '20%';
        if(this.step == 'size') return '40%';
        if(this.step == 'trip') return '60%';
        if(this.step == 'lookbook') return '80%';
        if(this.step == 'checkout') return '100%';
      } else {
        if(this.step == 'trip') return '20%';
        if(this.step == 'style') return '40%';
        if(this.step == 'size') return '60%';
        if(this.step == 'lookbook') return '80%';
        if(this.step == 'checkout') return '100%';
      }
    },
    styleFirst: function() {
      return this.$store.getters.wizardNavigator.styleFirst;
    },
    showSizeAndStyle: function() {
      return this.$store.getters.wizardNavigator.showSizeAndStyle;
    }
  },
  methods: {
    stepActive: function(step) {
      if(this.step == 'checkout') return true;
      if(this.step == 'lookbook' && step != 'checkout') return true;

      if(this.styleFirst) {
        if(this.step == 'trip' && step != 'checkout' && step != 'lookbook') return true;
        if(this.step == 'size' && (step == 'size' || step == 'style')) return true;
        if(this.step == 'style' && step == 'style') return true;
      } else {
        if(this.step == 'size' && step != 'checkout' && step != 'lookbook') return true;
        if(this.step == 'style' && (step == 'style' || step == 'trip')) return true;
        if(this.step == 'trip' && step == 'trip') return true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/_mixins.scss';

  .progress-container {
    position: relative;
    margin: 0px !important;
    padding: 0px !important;

    .progress-bar {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 20%;
      background-color: #000;
      z-index: 0;

      @include transition(all 1s ease-in-out);
    }

    .flex {
      color: #777;
      font-weight: bold;
      z-index: 1;

      @include transition(all 1s ease-in-out);

      &.active {
        color: #FFF;
      }
    }
  }
</style>
